module.exports = __webpack_public_path__ + "static/media/objects2_23.cf71e325.svg";